import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { storeFallbackCookieAuthForRoute } from './cookieAuthFallbacks'

export function useStoreFallbackCookieAuthOnMount(isAuthenticated: boolean) {
  const { pathname } = useLocation()

  useEffect(() => {
    if (!isAuthenticated) return

    storeFallbackCookieAuthForRoute(pathname)
  }, [isAuthenticated, pathname])
}
